import React from "react";

export const ValidationMessage = (props) => {
    if(props.validationResult.isValid){
        return <span className="validation-is-valid"/>
    }
    return (
        <div className="validation-problems">
            {props.validationResult.rules.filter(item => !item.isValid).map((item,index) => {
                return <div className="validation-problem" key={index}>{item.message}</div>
            })}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/common/components/forms/validation-message.jsx